export default {
    "title": "🇵🇹 Português",

    "首页": "Início",
    "关于": "Sobre",
    "会员": "Membresia",
    "推荐计划": "Programa de Referência",
    "个人": "Perfil",
    "推荐": "Referência",
    "预订": "Reservar Agora",
    "事件": "Evento",
    "登出": "Sair",
    "登录": "Entrar",
    "注册": "Registrar",
    "我们的应用程序现在可用": "Nosso aplicativo disponível agora",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "Para uma melhor experiência, acabamos de lançar nosso aplicativo móvel para reservas mais rápidas e sem interrupções.",
    "iOS版下载（即将推出）": "Download para iOS (Em Breve)",
    "Android版下载（即将推出）": "Download para Android (Em Breve)",
    "为什么选择我们": "Por que nos escolher",
    "我们卓越的服务。": "Nossos serviços excepcionais.",
    "收入最高的酒店": "Atrações com Maior Rendimento",
    "我们的合作酒店收入最高。": "Nossas Atrações com maior rendimento.",
    "回报": "Retornos",
    "最具特色的酒店": "Atrações Mais Destacadas",
    "我们平台上最有特色的酒店。": "Os hotéis mais destacados em nossa plataforma.",
    "热门国家和目的地": "Principais Países e Destinos",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "Explore algumas das melhores dicas da cidade com nossos parceiros e amigos.",
    "酒店": "Atrações",
    "预订酒店并开始赚取": "Explore o mundo conosco!",
    "让我们开始与TitanTraveler一起探索世界": "Prepare-se para explorar o mundo das Atrações conosco!",
    "客户评价": "Depoimentos",
    "查看我们用户的真实评价。": "Veja nossos depoimentos autênticos de nossos usuários.",
    "银行卡列表": "Lista de Cartões Bancários",
    "银行列表": "Lista de Bancos",
    "持卡人姓名": "Nome do Titular",
    "银行卡号": "Número da Conta Bancária (IBAN)",
    "支付密码": "Senha de Pagamento",
    "提交": "Enviar",
    "Pix列表": "Lista de Pix",
    "Pix类型": "Tipo de Pix",
    "Pix账号": "Conta Pix",
    "账号列表": "Lista de Contas",
    "网络": "Rede",
    "地址": "Endereço",
    "备注": "Nota",
    "充值金额": "Valor do Recarregamento",
    "支付类型": "Tipo de Pagamento",
    "支付银行": "Banco de Pagamento",
    "USDT地址": "Endereço USDT",
    "二维码": "Código QR",
    "充值渠道": "Canal de Recarregamento",
    "充值凭证": "Comprovante de Recarregamento",
    "立即登录": "Entrar Agora",
    "用户名": "Nome de Usuário",
    "密码": "Senha",
    "邀请码": "Código de Convite",
    "确认密码": "Confirmar Senha",
    "手机": "Celular",
    "注册2": "Cadastrar",
    "金额": "Valor",
    "新增": "Novo",
    "我们的精彩": "Nosso Incrível",
    "故事": "História",
    "奖项": "Prêmios",
    "获得": "Obtido",
    "钱包余额": "Saldo da Carteira",
    "累计佣金": "Comissão Acumulada",
    "今日奖励": "Recompensas de Hoje",
    "总行程": "Total de Viagens",
    "访问行程": "Viagens Visitadas",
    "酒店历史": "Detalhes do Pedido",
    "单价": "Preço",
    "数量": "Quantidade",
    "总额": "Total",
    "奖励": "Recompensas",
    "上一页": "Anterior",
    "下一页": "Próximo",
    "每套预订量": "Reservas por Conjunto",
    "预订奖励": "Recompensa de Reserva",
    "每日预订": "Reserva Diária",
    "手机号码": "Número de Telefone",
    "修改密码": "Alterar Senha",
    "登录密码": "Senha de Login",
    "当前密码": "Senha Atual",
    "新密码": "Nova Senha",
    "确认新密码": "Confirmar Nova Senha",
    "保存修改": "Salvar Alterações",
    "充值": "Recarregar",
    "我们的": "Nosso",
    "复制": "Copiar",
    "分享链接": "Compartilhar Link",
    "搜索酒店": "Reservar Viagem",
    "实际等级": "Nível Real",
    "升级": "Atualizar",
    "已完成预订": "Reservas Concluídas",
    "登录时间": "Hora de Login",
    "信誉分": "Credibilidade",
    "控制菜单": "Menu do Painel",
    "提现": "Sacar",
    "提现账号": "Conta de Saque",
    "你确定要删除此账号吗": "Tem certeza de que deseja excluir esta conta?",
    "你确定要删除此地址吗": "Tem certeza de que deseja excluir este endereço?",
    "提示": "Dicas",
    "是": "Sim",
    "否": "Não",
    "全部": "Todos",
    "待处理": "Pendente",
    "冻结中": "Congelando",
    "已完成": "Concluído",
    "订阅": "Assinar",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Quer ser notificado quando lançarmos um novo modelo ou uma atualização? Basta se inscrever e enviaremos uma notificação por e-mail.",
    "我们的伙伴": "Nossos parceiros",
    "关于我们": "SOBRE NÓS",
    "实时聊天支持": "Suporte por Chat Ao Vivo",
    "在线聊天": "Chat Ao Vivo",
    "创建时间": "Hora de Criação",
    "你确定要登出当前账号吗？": "Você quer sair da conta atual?",
    "请输入你的邮箱": "Digite seu E-mail",
    "好评": "Muito Bom",
    "条评论": "Avaliações",
    "平均每晚": "Média/Noche",
    "旅行旅程": "Viagens",
    "正在寻找酒店": "Procurando uma viagem",
    "开始预订": "Começar Reserva",
    "旅程价格": "Preço da Viagem",
    "佣金": "Comissões",
    "底部-about": "Somos uma agência de marketing digital com sede na Califórnia, Estados Unidos, que permite que empresas tenham sucesso no mundo digital através de estratégias de marketing inovadoras e baseadas em dados, serviço personalizado e uma mentalidade de crescimento que acompanha as tendências do setor. Se você precisa de uma agência de SEO, designer de sites, gestão de pagamento por clique, estratégia de marca, desenvolvimento de conteúdo ou outros serviços de marketing digital, a Tours4fun possui a experiência e a expertise para ajudá-lo a alcançar seus objetivos em um mundo orientado a resultados.",
    "立即预订": "Reservar agora",
    "搜索": "Pesquisar",
    "快乐的客户": "Cliente Feliz",
    "快乐的酒店老板": "Proprietário de Hotel Feliz",
    "评论1": "Arquitetura nos edifícios.",
    "评论2": "Este é um ótimo lugar para caminhar com ruas estreitas e uma arquitetura adorável nos edifícios.",
    "评论3": "Praça bonita entre a praia e a Avenida Central.",
    "评论4": "Edifícios muito legais com uma história interessante.",
    "评论5": "Muitos restaurantes para escolher e uma atmosfera muito relaxada.",
    "评论6": "Terra bonita com adoráveis pomares de laranjas e animais.",
    "评论7": "Ótimo lugar para uma escapada de fim de semana.",
    "评论8": "Lugar interessante ......",
    "评论9": "Um ótimo lugar para relaxar e observar o mundo passar.",
    "评论10": "Clube de praia de alto padrão que é uma linda homenagem àqueles que morreram na guerra.",
    "评论11": "Há tanto para ver e é um ótimo lugar para férias e relaxar!",
    "评论12": "Primeira vez aqui e foi muito agradável, voltarei na próxima vez.",
    "评论13": "Foi uma experiência diferente e me senti ótimo, os locais eram muito amigáveis e educados!",
    "推荐计划1": "Os usuários da plataforma podem convidar outros para se tornarem agentes da plataforma através de códigos de referência e se tornarem sua linha descendente.",
    "推荐计划2": "Como linha ascendente, você pode extrair uma certa porcentagem do lucro de sua linha descendente, e o lucro obtido pela linha ascendente será diretamente devolvido à conta da plataforma da linha ascendente ou ao relatório da equipe.",
    "推荐计划3": "Nota: Todos os agentes / linhas descendentes da plataforma receberão uma certa porcentagem dos lucros e recompensas da plataforma, desenvolver uma equipe não afeta os lucros e recompensas de qualquer agente ou linha descendente.",
    "评分": "Avaliação",
    "评论": "Comentário",
    "酒店很棒": "O hotel é ótimo",
    "终于体验了，酒店非常好": "Finalmente experimentei, o hotel é muito bom",
    "我对酒店非常满意并推荐预订": "Estou muito satisfeito com o hotel e recomendo a reserva",
    "我很高兴很满意，价格实惠": "Estou muito feliz e satisfeito, o preço é acessível",
    "服务非常好，我非常喜欢": "O serviço é muito bom, eu gosto muito",
    "体验很不错，朋友已经第二次预订了": "A experiência foi muito boa, meu amigo já reservou pela segunda vez",
    "酒店环境优美": "Ambiente do hotel bonito",
    "酒店卫生干净": "Hotel é higiênico e limpo",
    "工作人员态度非常好": "Atitude da equipe é muito boa",
    "酒店服务很棒": "O serviço do hotel é ótimo",
    "你还没有设置支付密码，请前往设置": "Você ainda não configurou uma senha de pagamento, por favor vá para as configurações",
    "订单": "Pedidos",
    "复制成功": "Cópia bem-sucedida",
    "团队与条件": "Termos e Condições",
    "站内信": "Mensagens do Site",
    "请联系客服升级会员": "Por favor, entre em contato com o suporte ao cliente para atualizar a membresia",
    "我已阅读并同意": "Li e concordo com o",
    "注册协议": "Acordo de Registro",
    "忘记密码": "Esqueceu a senha",
    "账户明细": "Detalhes da Conta",
    "时间": "Hora",
    "类型": "Tipo",
    "代理支持": "Suporte ao Agente",
    "冻结金额": "Valor Congelado",
    "点击下面的金蛋抽取奖励": "Clique no ovo de ouro abaixo para ganhar o prêmio",
    "恭喜您中奖了！": "Parabéns por ganhar!",
    "很遗憾，您没有中奖": "Infelizmente, você não ganhou",
    "公告": "Aviso",
    "恭喜您获得彩蛋": "Parabéns por conseguir o ovo de Páscoa"
}